import { BaseModel } from '../email-template/base-model.interface';
import BlockModel from '../email-template/block-model.interface';
import { NotificationInitVariables } from '../template/notifications-model.interface';

export interface MetaSingleImageCtaTextModel extends BaseModel {
  variables?: { [key: string]: string } | MetaSingleImageCtaTextVariables;
}

export interface MetaSingleImageCtaTextVariables {
  Text: string;
}

export class MetaSingleImageCtaTextInitVariables implements MetaSingleImageCtaTextVariables {
  Text = '';
}

export class MetaSingleImageCtaTextInitModel implements BlockModel {
  blockId: string = '';
  count: number = 0;
  name: string = '';
  variables: { [key: string]: string };
  notifications: NotificationInitVariables[];

  constructor() {
    const initVars = new MetaSingleImageCtaTextInitVariables();
    this.variables = { ...initVars };
    this.notifications = [new NotificationInitVariables()];
  }
}